module.exports = __webpack_public_path__ + "img/pms_4.a7763913.png";